module.exports = __webpack_public_path__ + "static/media/result.6963559a.png";